import React from 'react';
import Slider from 'react-slick';
import '../Styles/Home.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function Home() {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    cssEase: 'linear'
  };

const slides = [
  {
    background: 'slide1',
    title: 'Welcome to',
    highlight: 'IQube Technologies',
    text: 'Innovating your digital journey with cutting-edge technologies. We specialize in delivering high-impact software solutions tailored to business needs.',
    button: 'Explore Services'
  },
  {
    background: 'slide2',
    title: 'We Craft',
    highlight: 'UI/UX Designs',
    text: 'Beautiful, user-centered designs that elevate your brand. From wireframes to interactive prototypes, we build interfaces your users love.',
    button: 'Our Design Work'
  },
  {
    background: 'slide3',
    title: 'Powered by',
    highlight: 'GraphQL APIs',
    text: 'Experience fast and flexible data queries with GraphQL. We architect efficient APIs that scale with your frontend needs.',
    button: 'See GraphQL Benefits'
  },
  {
    background: 'slide4',
    title: 'Boost Business with',
    highlight: 'Content Square',
    text: 'Turn content into conversions. With data-driven strategies, we analyze user behavior and optimize content for maximum engagement.',
    button: 'Content Solutions'
  },
  {
    background: 'slide5',
    title: 'We Ensure',
    highlight: 'Governance & Security',
    text: 'Compliance-first development to protect your data and build trust. We implement robust governance frameworks and secure coding practices.',
    button: 'Governance Services'
  },
  {
    background: 'slide6',
    title: 'Balancing',
    highlight: 'Price, Quality & Technology',
    text: 'Smart budgeting with high-quality solutions. We deliver value without compromise, integrating modern technologies at cost-effective rates.',
    button: 'Explore Pricing'
  }
];

  return (
    <section id="home" className="home-section">
      <Slider {...settings} className="background-slider">
        {slides.map((slide, index) => (
          <div key={index} className={`slide ${slide.background}`}>
            <div className="overlay"></div>
            <div className="container text-center content">
              <h1 className="display-4">
                {slide.title} <span className="highlight">{slide.highlight}</span>
              </h1>
              <p className="lead mt-3">{slide.text}</p>
              <a href="#services" className="btn btn-primary mt-4">{slide.button}</a>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default Home;
